import React from 'react';
import { Box, Card, IconButton, Icons, Stack, Typography } from '@curves/ui-base';
import { Overview } from '@curves/ui-shared';

import { usePointsContext } from '@Local/Points/Components/PointsContext';
import usePointsRedeemOrderApi from '@Apis/usePointsRedeemOrderApi';
const headerRow = [
    {
        cellKey: 'imageSrc',
        headerLabel: '贈品',
        align: 'left',
        isFixed: true,
        isFixedLeft: true,
        style: { minWidth: 50, left: 0 },
        formatCell: (value, rowData, { onClick }) => {
            return (
                <Stack alignItems="center" spacing={1}>
                    <Box className="product-gift-img-label">
                        <img src={value} alt={rowData.itemName} />
                    </Box>
                    <Typography variant="h6" className="font-weight-bold">
                        {rowData.itemName}
                    </Typography>
                    <Icons.QuestionCircle
                        className="cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onClick(rowData);
                        }}
                    />
                </Stack>
            );
        },
    },
    {
        cellKey: 'points',
        headerLabel: '兌換點數',
        align: 'center',
        width: 8,
        style: { minWidth: 50 },
        formatCell: (value) => {
            return <Typography variant="h5" component="span">{`${value}點`}</Typography>;
        },
    },
    {
        cellKey: 'activityRedeemQty',
        headerLabel: '兌換數量',
        align: 'center',
        width: 8,
        style: { minWidth: 50 },
        formatCell: (value) => {
            return (
                <Typography variant="h5" component="span">
                    {value}
                </Typography>
            );
        },
    },
];
const PointsProductGiftItemExchangeTable = React.forwardRef((props, ref) => {
    const { deletePointsRewardOrderCleanCacheApi } = usePointsRedeemOrderApi();
    const { dialogRef, sourceData, refresh } = usePointsContext();
    const handleProductsInfoOnClick = (rowData) => {
        dialogRef.current.openPointsProductGuideDialog(rowData);
    };
    const handleRowOnClick = (rowData) => {
        dialogRef.current.openProductGiftExchangeRecordDialog(rowData);
    };
    const handleRefreshOnClick = () => {
        doCleanCacheApi();
    };
    const doCleanCacheApi = async () => {
        await deletePointsRewardOrderCleanCacheApi();
        setTimeout(refresh, 500);
    };
    // 無分頁，以整批資料筆數組出 Overview 所需資料（初始 sourceData 為空物件，需轉成陣列）
    const list = Array.isArray(sourceData) ? sourceData : [];
    const contextValue = {
        overviewData: {
            list,
            pagination: { pageIndex: 1, pageSize: list.length, totalCount: list.length, totalPage: 0 },
        },
    };
    return (
        <Card className="mt-4">
            <Card.CardContent className="p-3">
                <Overview contextValue={contextValue}>
                    <Stack className="overview__toolbar" alignItems="center" justifyContent="end">
                        <Typography variant="body2">{`(共${list.length}筆)`}</Typography>
                        <IconButton onClick={handleRefreshOnClick}>
                            <Icons.Refresh />
                        </IconButton>
                    </Stack>
                    <Overview.Table
                        headerRow={headerRow}
                        cardProps={{ className: 'theme-gray' }}
                        cellWidth={12}
                        isFixed
                        rowOnClick={handleRowOnClick}
                        cellRenderContext={{ onClick: handleProductsInfoOnClick }}
                    />
                </Overview>
            </Card.CardContent>
        </Card>
    );
});
export default PointsProductGiftItemExchangeTable;
